import { defineStore } from 'pinia';
import { computed } from 'vue';
import { useGaiaStore } from './gaiaStore';

const ALL_INTEGRATIONS = ['gaia'] as const;

export const useIntegrationsStore = defineStore('integrations', () => {
  const gaiaStore = useGaiaStore();

  const activeIntegrations = computed(() => ({
    gaia: Boolean(gaiaStore.currentToken),
  }));

  const availableIntegrations = computed(() => ALL_INTEGRATIONS);

  function clearAll(): void {
    gaiaStore.clearAll();
  }

  return {
    activeIntegrations,
    availableIntegrations,
    clearAll,
  };
});
